import React from 'react';
import { compose, setPropTypes } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ConfirmSettingShopDialog from '../molecules/ConfirmSettingShopDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const button = enhance(
  ({
    classes,
    message,
    content,
    openDialog,
    updateOpenDialog,
    onClickAction,
    disabled,
    settings,
    listDay,
    validate,
    hasSetting,
    shopHolidayList
  }) => {
    const okAction = () => {
      updateOpenDialog(false);
      onClickAction();
    };
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          className={[classes.button]}
          onClick={() => {
            const valid = validate();
            if (valid) {
              updateOpenDialog(true);
            }
          }}
          disabled={disabled}
        >
          {content}
        </Button>
        <ConfirmSettingShopDialog
          hasSetting={hasSetting}
          openConfirm={openDialog}
          updateOpenConfirm={updateOpenDialog}
          okAction={() => {
            okAction();
          }}
          settings={settings}
          listDay={listDay}
          message={message}
          shopHolidayList={shopHolidayList}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
